import React, { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';

import OfferSearchForm from '~/components/Common/Forms/OfferSearchForm';
import OfferList from '~/components/Common/OfferListContainer';

import useAppNavigation from '~/hooks/useAppNavigation';

import OffersService from '~/services/OffersService';

import { addQuery } from '~/utils/url';

function OffersSearch() {
  const [searchString, setSearchString] = useState('');
  const [ledExperience, setLedExperience] = useState(false);
  const [destinations, setDestinations] = useState<Array<{ value: string; label: string }>>([]);

  const { push } = useAppNavigation();
  const location = useLocation();

  useEffect(() => {
    const fetchDestinations = async () => {
      const response = await OffersService.getAllLocations();
      setDestinations(response.result || []);
    };
    fetchDestinations();
  }, []);

  const searchQuery = (query: string) => {
    setSearchString(query);
    // Remove query params
    const newLocation = addQuery(location, { page: null });
    push(newLocation);
  };

  const urlBuilder = (row: App.Offer) => {
    return `/finance/offers/${row.id_salesforce_external}`;
  };

  return (
    <>
      <OfferSearchForm destinations={destinations} searchQuery={searchQuery} setLedExperience={setLedExperience} />
      <OfferList urlBuilder={urlBuilder} searchString={searchString} ledExperience={ledExperience} />
    </>
  );
}

export default OffersSearch;
